import { createContext, useContext } from "react";
import { AugmentedRenewal, Instruction, IpRight, Renewal } from "./renewal_types";
import { usePatents } from "src/patents/PatentsProvider";
import { useIpRights } from "./IpRights";
import { Member } from "src/patents/patents";
import { IpRightImportStatusInfo, RenewalNoticeStatusInfo } from "../state/modern_states";
import { extractDueDateStatus } from "../components/dueDates";
import { useRenewal as usePrRenewal } from "../patent_renewal/patent_renewals"
import { useSettings } from "./Settings";

// Setting an instruction to undefined means, "taking back a decision"
export const RenewalsContext = createContext({
    renewals: [] as Renewal[],
    instruct: (renewalId: string, instruction: Instruction | undefined) => Promise.resolve(),
    bulkInstruct: (instructions: Record<string, Instruction | undefined>) => Promise.resolve(),
    isLoading: false as boolean,
})

export function useRenewals() {
    return useContext(RenewalsContext)
}


// TODO: this does not work
function useRenewal_(id: number | string) {
    const {memberByReference} = usePatents()
    const {ipRightById} = useIpRights()
    const {renewals, instruct} = useRenewals()
    const renewal = renewals.find(r => r.id == id)

    const ipRight: IpRight | undefined = ipRightById[renewal?.ipRightId]
    const member = memberByReference[ipRight?.clientReference]
    // console.log({ipRightById, renewals, renewal, ipRight, member})

    return {renewal, instruct, ipRight, member}
}

const RenewalInstructionContext = createContext({
  renewal: undefined as (Renewal | undefined),
  instruct: (renewalId: string, instruction: Instruction) => Promise.resolve(),
  ipRight: undefined as (IpRight | undefined), 
  member: undefined as (Member | undefined),
  id: '' as string,
})

export function RenewalInstructionProvider({children, id}) {
  const { implementation } = useSettings()
  switch (implementation) {
    case 'patent-renewal':
        return <PrRenewalInstructionProvider {...{children, id}} />
    default:
        return <_RenewalInstructionProvider {...{children, id}} />
  }
}

function PrRenewalInstructionProvider({children, id}) {
    const value = usePrRenewal(id)
    return <RenewalInstructionContext.Provider value={{...value, id}}>{children}</RenewalInstructionContext.Provider>
}

function _RenewalInstructionProvider({children, id}) {
    const value = useRenewal_(id)
    return <RenewalInstructionContext.Provider value={{...value, id}}>{children}</RenewalInstructionContext.Provider>
}

export function useRenewal() {
    return useContext(RenewalInstructionContext)
}

export const RenewalOverviewContext = createContext({
    renewals: [] as Renewal[],
    ipRight: {} as IpRight,
    actualIpRight: {} as any | undefined,
    member: {} as Member,
    instruct: (renewalId: string, instruction: Instruction | undefined) => Promise.resolve(),
    ipRightImportStatus: {} as IpRightImportStatusInfo,
    renewalsStatus: {} as RenewalNoticeStatusInfo & {total: number},
    isLoading: false as boolean,
})

export function useRenewalOverview() {
    return useContext(RenewalOverviewContext)
}

export function useAugmentRenewal() {

    const {ipRightById} = useIpRights()
    const {memberByReference} = usePatents()
    const today = new Date().toISOString().split('T')[0]

    function augmentRenewal(renewal: Renewal): AugmentedRenewal {
        const ipRight: IpRight = ipRightById[renewal.ipRightId]
        // console.log({ipRight})
        const member = memberByReference[ipRight?.clientReference]
        const status = extractDueDateStatus(renewal, today)
        return {...renewal, member, status}
    }

    return {augmentRenewal}
}